import { useMemo } from 'react';

import { useDataSource } from '@/features/data/DataSourceContext';

import { useListQuickSearchHistoryQuery } from './api/quickSearch.api';

/** Breadcrumb label for `quick-search/:historyEntryId` — the query. */
export function useQuickSearchQueryResolver(): (entryId: string) => string | undefined {
  const { source } = useDataSource();
  const { data } = useListQuickSearchHistoryQuery({ source, params: undefined });
  const labels = useMemo(
    () => new Map(data?.map((entry) => [entry.id, entry.terms.join(', ')]) ?? []),
    [data],
  );
  return (entryId) => labels.get(entryId);
}
